import FormattedMessage from 'I18n/components/FormattedMessage';
import { StatusTag } from 'foundations-components/transitional/components/StatusTag';
import { getStatusCategory, getStatusKey } from 'automation-ui-log-events/utils/logEventUtils';
import { jsx as _jsx } from "react/jsx-runtime";
const LogEventStatus = ({
  logEvent,
  marginTop
}) => {
  const statusCategory = getStatusCategory(logEvent);
  const statusKey = getStatusKey(statusCategory);
  return /*#__PURE__*/_jsx(StatusTag, {
    use: statusCategory,
    display: "block",
    marginBlockStart: marginTop,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: statusKey
    })
  });
};
export default LogEventStatus;